import React from 'react'

function index() {
    return (
        <div>
            <h1>cities</h1>
        </div>
    )
}

export default index
